<template>
  <div class="">
    <div
      v-for="(s) in sectorList"
      :key="s.id"
      class="my-1"
    >
      <a
        class="text-dark "
        :class="[!s.parent?'font-weight-bold':'' ]"
      >&bull; {{ s.name }}</a>

      <div class="ml-4">
        <SelectedSectorView
          :sectors="sectors"
          :parent-id="s.id"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SelectedSectorView",
  props: {
    sectors: {
      default() {
        return [];
      }
    },
    parentId: {
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      sectorList: []
    }
  },
  watch: {
    sectors: {
      deep: true,
      handler() {
        this.sectorList = this.buildSectorList(this.sector);
      }
    },
  },


  mounted() {
    this.sectorList = this.buildSectorList();
  },
  methods: {

    buildSectorList() {

      let list = [];

      this.sectors.forEach(s => {

        let p = this.getParentSectorUntil(s, this.parentId);
        if (p) {
          if (list.filter(s => s.id === p.id).length < 1) {
            list.push(p);
          }
        }
      })

      return Array.from(new Set(list));
    }
    ,

    getParentSectorUntil(sector, parentId) {
      if (sector.id === parentId) {
        return null;
      } else {
        if (!sector.parent) {
          if (parentId < 1) {
            return sector;
          } else {
            return null;
          }
        } else {
          if (sector.parent.id === parentId) {
            return sector;
          }
          return this.getParentSectorUntil(sector.parent, parentId);
        }
      }
    }
  },
}
</script>

<style scoped>

</style>